export default __webpack_public_path__ + "static/abouthero-xs-e6d2bfbdb0155dc3165b5ce2451a2d20.jpg";